/*
Auftragsstatus: Hier kann über den Status des Auftrags gesucht werden. Mögliche Ausprägungen dabei sind:
1: Ankauf von Sparkasse erfasst, aber noch nicht bei uns eingeliefert
2: Auftrag erfasst; steht zur Verarbeitung an
3: an DC-Sehan übergeben
4: Fehler - Grund siehe Fehlerprotokoll
5: Auftrag verarbeitet / Auftrag ausgedruckt
6: Onlinestorno durch Sparkasse / Storno durch BayernLB
7: in VerSE-RS-Anwendung erfasst (historisch)
8: in VerSE-RS-Anwendung verarbeitet / gedruckt (historisch)
9: Internes Storno (w/ OSPlus)
11: im VerSE-RS-Abschluss verarbeitet – Monatsultimo (historisch)
12: im VerSE-RS-Abschluss verarbeitet Tagesabschluss (historisch)
https://blbintra.prod.blb.de/wiki/display/VERSE/Intra-V+Funktion+Anzeigen
*/
export const AUFTRAG_STATUS = {
  OPEN_AK: {
    KEY: 1,
    BEZEICHNUNG: "Ankauf erfasst",
    INFO: "Ankauf von Sparkasse erfasst, aber noch nicht bei uns eingeliefert"
  },
  OPEN_VK: {
    KEY: 2,
    BEZEICHNUNG: "Auftrag erfasst",
    INFO: "Auftrag erfasst; steht zur Verarbeitung an"
  },
  BOOKED: {
    KEY: 3,
    BEZEICHNUNG: "an DC-Sehan übergeben"
  },
  ERROR: {
    KEY: 4,
    BEZEICHNUNG: "Fehler",
    INFO: "Fehler - Grund siehe Fehlerprotokoll"
  },
  CLOSED: {
    KEY: 5,
    BEZEICHNUNG: "Auftrag verarbeitet",
    INFO: "Auftrag verarbeitet / Auftrag ausgedruckt"
  },
  ONLINE_STORNO: {
    KEY: 6,
    BEZEICHNUNG: "Online Storno",
    INFO: "Onlinestorno durch Sparkasse / Storno durch BayernLB"
  },
  STORNO: {
    KEY: 9,
    BEZEICHNUNG: "Internes Storno",
    INFO: "Internes Storno (w/ OSPlus)"
  },
  TCM_LAEUFT: {
    KEY: 70,
    BEZEICHNUNG: "Prüfung läuft",
    INFO: "TCM-Prüfung läuft"
  },
  TCM_GESPERRT: {
    KEY: 71,
    BEZEICHNUNG: "gesperrt",
    INFO: "gesperrt wg. TCM-Prüfung"
  }
};
